// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.order-guide-page {
    max-width: 1200px;
    margin: 40px auto;
    padding: 0 20px;
    font-family: 'Noto Sans KR', sans-serif;
    color: #333;
}

.og-breadcrumb {
    font-size: 14px;
    color: #888;
    margin-bottom: 40px;
}

.og-breadcrumb .current {
    font-weight: 500;
    color: #333;
}

.og-main-title {
    font-size: 32px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 30px;
}

.og-progress-bar {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 50px;
    padding: 20px 0;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
}

.og-progress-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #ccc;
    font-size: 14px;
    width: 150px;
    text-align: center;
}

.og-progress-step.active {
    color: #E84100;
    font-weight: bold;
}

.og-step-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #ccc;
    margin-bottom: 10px;
    border: 2px solid #ccc;
}

.og-progress-step.active .og-step-dot {
    background-color: #E84100;
    border-color: #E84100;
}

.og-progress-line {
    flex-grow: 1;
    height: 2px;
    background-color: #ccc;
    max-width: 200px;
}

/* 진행 바 활성화 스타일 */
.og-progress-line.active {
    background-color: #E84100;
}

/* 단계별 컨텐츠 스타일 */
.og-process-list {
    list-style: none;
    padding: 0;
    margin: 20px 0;
}

.og-process-list li {
    margin-bottom: 20px;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 8px;
    border-left: 4px solid #E84100;
}

.og-process-list li strong {
    display: block;
    color: #333;
    font-size: 16px;
    margin-bottom: 8px;
}

.og-process-list li p {
    margin: 0;
    color: #666;
    line-height: 1.6;
}

/* 안내 박스 스타일 */
.og-notice-box {
    background-color: #fff3cd;
    border: 1px solid #ffeaa7;
    border-radius: 8px;
    padding: 20px;
    margin-top: 20px;
}

.og-notice-box p {
    margin: 0 0 10px 0;
    color: #856404;
}

.og-notice-box p:last-child {
    margin-bottom: 0;
}

/* 타임라인 스타일 */
.og-timeline {
    position: relative;
    margin: 20px 0;
    padding-left: 30px;
}

.og-timeline::before {
    content: '';
    position: absolute;
    left: 15px;
    top: 0;
    bottom: 0;
    width: 2px;
    background-color: #E84100;
}

.og-timeline-item {
    position: relative;
    margin-bottom: 30px;
    padding-left: 30px;
}

.og-timeline-item:last-child {
    margin-bottom: 0;
}

.og-timeline-dot {
    position: absolute;
    left: -8px;
    top: 5px;
    width: 16px;
    height: 16px;
    background-color: #E84100;
    border-radius: 50%;
    border: 3px solid #fff;
    box-shadow: 0 0 0 2px #E84100;
}

.og-timeline-content h4 {
    margin: 0 0 8px 0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

.og-timeline-content p {
    margin: 0;
    color: #666;
    line-height: 1.6;
}

/* 연락처 박스 스타일 */
.og-contact-box {
    background-color: #e8f4fd;
    border: 1px solid #b8daff;
    border-radius: 8px;
    padding: 20px;
    margin-top: 20px;
}

.og-contact-box h3 {
    margin: 0 0 15px 0;
    font-size: 18px;
    color: #0c5aa6;
}

.og-contact-box > p {
    margin: 0 0 15px 0;
    color: #0c5aa6;
    line-height: 1.6;
}

.og-contact-info {
    background-color: #fff;
    padding: 15px;
    border-radius: 6px;
    border: 1px solid #b8daff;
}

.og-contact-info p {
    margin: 0 0 8px 0;
    color: #333;
}

.og-contact-info p:last-child {
    margin-bottom: 0;
}

.og-content-box {
    text-align: center;
    max-width: 900px;
    margin: 80px auto;
    padding: 40px;
    border: 1px solid #eee;
    border-radius: 5px;
}

.og-main-text {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 30px;
}

.og-info-box {
    background-color: #f9f9f9;
    padding: 20px;
    margin-bottom: 30px;
}

.og-info-box p {
    font-size: 15px;
    margin-bottom: 20px;
}

.og-info-box ul {
    list-style: none;
    padding: 0;
    margin: 0;
    font-size: 16px;
    line-height: 1.8;
}

.og-info-box .og-label {
    font-weight: bold;
    color: #E84100;
    margin-right: 10px;
}

.og-sub-text {
    font-size: 15px;
    color: #555;
    line-height: 1.6;
    margin: 10px 0;
}

/* 버튼 레이아웃 개선 */
.og-actions {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    margin-top: 40px;
}

.og-actions button {
    flex: 0 0 200px;
}

.og-btn-light,
.og-btn-dark {
    padding: 15px 40px;
    font-size: 16px;
    border-radius: 5px;
    cursor: pointer;
    font-weight: bold;
}

.og-btn-light {
    background-color: #fff;
    border: 1px solid #ccc;
    color: #333;
}

.og-btn-dark {
    background-color: #333;
    border: 1px solid #333;
    color: #fff;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .order-guide-page {
        margin: 20px auto;
    }

    .og-main-title {
        font-size: 28px;
    }

    .og-content-box {
        margin: 40px auto;
        padding: 30px;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .order-guide-page {
        padding: 0 15px;
        margin: 15px auto;
    }

    .og-breadcrumb {
        font-size: 12px;
        margin-bottom: 20px;
    }

    .og-main-title {
        font-size: 24px;
        margin-bottom: 20px;
    }

    .og-progress-bar {
        flex-direction: column;
        gap: 15px;
        border: none;
        padding: 0;
        margin-bottom: 30px;
        align-items: flex-start;
    }

    .og-progress-step {
        flex-direction: row;
        width: 100%;
        text-align: left;
    }

    .og-progress-line {
        display: none;
    }

    .og-content-box {
        margin: 20px auto;
        padding: 20px;
    }

    .og-main-text {
        font-size: 16px;
    }

    .og-info-box p {
        font-size: 14px;
    }

    .og-info-box ul {
        font-size: 15px;
    }

    .og-actions {
        flex-direction: column;
        gap: 10px;
        margin-top: 30px;
    }

    .og-btn-light,
    .og-btn-dark {
        width: 100%;
        padding: 12px;
    }

    .og-timeline {
        padding-left: 20px;
    }
    
    .og-timeline-item {
        padding-left: 20px;
    }
    
    .og-timeline-dot {
        left: -6px;
        width: 12px;
        height: 12px;
    }
    
    .og-actions {
        flex-direction: column;
    }
    
    .og-actions button {
        max-width: none;
        width: 100%;
    }
} `, "",{"version":3,"sources":["webpack://./src/pages/css/OrderGuidePage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,uCAAuC;IACvC,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,iBAAiB;AACjB;IACI,yBAAyB;AAC7B;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;;AAEA,cAAc;AACd;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,aAAa;AACb;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,SAAS;IACT,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,WAAW;IACX,gBAAgB;AACpB;;AAEA,eAAe;AACf;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,WAAW;AACf;;AAEA,+BAA+B;AAC/B;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,aAAa;IACjB;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,YAAY;QACZ,UAAU;QACV,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,mBAAmB;QACnB,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,gBAAgB;IACpB;;IAEA;;QAEI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,WAAW;IACf;AACJ","sourcesContent":[".order-guide-page {\n    max-width: 1200px;\n    margin: 40px auto;\n    padding: 0 20px;\n    font-family: 'Noto Sans KR', sans-serif;\n    color: #333;\n}\n\n.og-breadcrumb {\n    font-size: 14px;\n    color: #888;\n    margin-bottom: 40px;\n}\n\n.og-breadcrumb .current {\n    font-weight: 500;\n    color: #333;\n}\n\n.og-main-title {\n    font-size: 32px;\n    font-weight: bold;\n    text-align: center;\n    margin-bottom: 30px;\n}\n\n.og-progress-bar {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 50px;\n    padding: 20px 0;\n    border-top: 1px solid #eee;\n    border-bottom: 1px solid #eee;\n}\n\n.og-progress-step {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    color: #ccc;\n    font-size: 14px;\n    width: 150px;\n    text-align: center;\n}\n\n.og-progress-step.active {\n    color: #E84100;\n    font-weight: bold;\n}\n\n.og-step-dot {\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    background-color: #ccc;\n    margin-bottom: 10px;\n    border: 2px solid #ccc;\n}\n\n.og-progress-step.active .og-step-dot {\n    background-color: #E84100;\n    border-color: #E84100;\n}\n\n.og-progress-line {\n    flex-grow: 1;\n    height: 2px;\n    background-color: #ccc;\n    max-width: 200px;\n}\n\n/* 진행 바 활성화 스타일 */\n.og-progress-line.active {\n    background-color: #E84100;\n}\n\n/* 단계별 컨텐츠 스타일 */\n.og-process-list {\n    list-style: none;\n    padding: 0;\n    margin: 20px 0;\n}\n\n.og-process-list li {\n    margin-bottom: 20px;\n    padding: 15px;\n    background-color: #f8f9fa;\n    border-radius: 8px;\n    border-left: 4px solid #E84100;\n}\n\n.og-process-list li strong {\n    display: block;\n    color: #333;\n    font-size: 16px;\n    margin-bottom: 8px;\n}\n\n.og-process-list li p {\n    margin: 0;\n    color: #666;\n    line-height: 1.6;\n}\n\n/* 안내 박스 스타일 */\n.og-notice-box {\n    background-color: #fff3cd;\n    border: 1px solid #ffeaa7;\n    border-radius: 8px;\n    padding: 20px;\n    margin-top: 20px;\n}\n\n.og-notice-box p {\n    margin: 0 0 10px 0;\n    color: #856404;\n}\n\n.og-notice-box p:last-child {\n    margin-bottom: 0;\n}\n\n/* 타임라인 스타일 */\n.og-timeline {\n    position: relative;\n    margin: 20px 0;\n    padding-left: 30px;\n}\n\n.og-timeline::before {\n    content: '';\n    position: absolute;\n    left: 15px;\n    top: 0;\n    bottom: 0;\n    width: 2px;\n    background-color: #E84100;\n}\n\n.og-timeline-item {\n    position: relative;\n    margin-bottom: 30px;\n    padding-left: 30px;\n}\n\n.og-timeline-item:last-child {\n    margin-bottom: 0;\n}\n\n.og-timeline-dot {\n    position: absolute;\n    left: -8px;\n    top: 5px;\n    width: 16px;\n    height: 16px;\n    background-color: #E84100;\n    border-radius: 50%;\n    border: 3px solid #fff;\n    box-shadow: 0 0 0 2px #E84100;\n}\n\n.og-timeline-content h4 {\n    margin: 0 0 8px 0;\n    font-size: 16px;\n    font-weight: 600;\n    color: #333;\n}\n\n.og-timeline-content p {\n    margin: 0;\n    color: #666;\n    line-height: 1.6;\n}\n\n/* 연락처 박스 스타일 */\n.og-contact-box {\n    background-color: #e8f4fd;\n    border: 1px solid #b8daff;\n    border-radius: 8px;\n    padding: 20px;\n    margin-top: 20px;\n}\n\n.og-contact-box h3 {\n    margin: 0 0 15px 0;\n    font-size: 18px;\n    color: #0c5aa6;\n}\n\n.og-contact-box > p {\n    margin: 0 0 15px 0;\n    color: #0c5aa6;\n    line-height: 1.6;\n}\n\n.og-contact-info {\n    background-color: #fff;\n    padding: 15px;\n    border-radius: 6px;\n    border: 1px solid #b8daff;\n}\n\n.og-contact-info p {\n    margin: 0 0 8px 0;\n    color: #333;\n}\n\n.og-contact-info p:last-child {\n    margin-bottom: 0;\n}\n\n.og-content-box {\n    text-align: center;\n    max-width: 900px;\n    margin: 80px auto;\n    padding: 40px;\n    border: 1px solid #eee;\n    border-radius: 5px;\n}\n\n.og-main-text {\n    font-size: 18px;\n    font-weight: 500;\n    margin-bottom: 30px;\n}\n\n.og-info-box {\n    background-color: #f9f9f9;\n    padding: 20px;\n    margin-bottom: 30px;\n}\n\n.og-info-box p {\n    font-size: 15px;\n    margin-bottom: 20px;\n}\n\n.og-info-box ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    font-size: 16px;\n    line-height: 1.8;\n}\n\n.og-info-box .og-label {\n    font-weight: bold;\n    color: #E84100;\n    margin-right: 10px;\n}\n\n.og-sub-text {\n    font-size: 15px;\n    color: #555;\n    line-height: 1.6;\n    margin: 10px 0;\n}\n\n/* 버튼 레이아웃 개선 */\n.og-actions {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 15px;\n    margin-top: 40px;\n}\n\n.og-actions button {\n    flex: 0 0 200px;\n}\n\n.og-btn-light,\n.og-btn-dark {\n    padding: 15px 40px;\n    font-size: 16px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-weight: bold;\n}\n\n.og-btn-light {\n    background-color: #fff;\n    border: 1px solid #ccc;\n    color: #333;\n}\n\n.og-btn-dark {\n    background-color: #333;\n    border: 1px solid #333;\n    color: #fff;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .order-guide-page {\n        margin: 20px auto;\n    }\n\n    .og-main-title {\n        font-size: 28px;\n    }\n\n    .og-content-box {\n        margin: 40px auto;\n        padding: 30px;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .order-guide-page {\n        padding: 0 15px;\n        margin: 15px auto;\n    }\n\n    .og-breadcrumb {\n        font-size: 12px;\n        margin-bottom: 20px;\n    }\n\n    .og-main-title {\n        font-size: 24px;\n        margin-bottom: 20px;\n    }\n\n    .og-progress-bar {\n        flex-direction: column;\n        gap: 15px;\n        border: none;\n        padding: 0;\n        margin-bottom: 30px;\n        align-items: flex-start;\n    }\n\n    .og-progress-step {\n        flex-direction: row;\n        width: 100%;\n        text-align: left;\n    }\n\n    .og-progress-line {\n        display: none;\n    }\n\n    .og-content-box {\n        margin: 20px auto;\n        padding: 20px;\n    }\n\n    .og-main-text {\n        font-size: 16px;\n    }\n\n    .og-info-box p {\n        font-size: 14px;\n    }\n\n    .og-info-box ul {\n        font-size: 15px;\n    }\n\n    .og-actions {\n        flex-direction: column;\n        gap: 10px;\n        margin-top: 30px;\n    }\n\n    .og-btn-light,\n    .og-btn-dark {\n        width: 100%;\n        padding: 12px;\n    }\n\n    .og-timeline {\n        padding-left: 20px;\n    }\n    \n    .og-timeline-item {\n        padding-left: 20px;\n    }\n    \n    .og-timeline-dot {\n        left: -6px;\n        width: 12px;\n        height: 12px;\n    }\n    \n    .og-actions {\n        flex-direction: column;\n    }\n    \n    .og-actions button {\n        max-width: none;\n        width: 100%;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
